/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Tysiav2Dashboard/view.blocks to change it.
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Tysiav2Dashboard({
  children,
  viewPath = "/DesignSystem/Svgs/Tysiav2Dashboard",
  alignSelf = "auto",
  marginTop = 0,
  marginBottom = 0,
  marginLeft = 0,
  marginRight = 0,
  opacity = 1,
  width = 12,
  height = 12,
  fill = "none",
  isAnimated,
  animation = "dash 5s linear forwards",
  strokeDashoffset = 1000,
  strokeDasharray = 1000,
  fill2 = "#9AA5B1"
  
}) {
  return (<React.Fragment
>
<svg
  data-testid="Tysiav2Dashboard.Svg"
  data-view-path={viewPath}
 viewBox="0 0 12 12"
 style={{'--as-1-1iXufb': alignSelf,'--mt-2-1iXufb': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--mb-3-1iXufb': typeof marginBottom === 'number' ? `${marginBottom}px` : marginBottom,'--ml-4-1iXufb': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft,'--mr-5-1iXufb': typeof marginRight === 'number' ? `${marginRight}px` : marginRight,'--o-6-1iXufb': opacity,'--w-10-1iXufb': typeof width === 'number' ? `${width}px` : width,'--h-11-1iXufb': typeof height === 'number' ? `${height}px` : height,'--f-12-1iXufb': fill,'--a-7-1iXufb': isAnimated ? animation : "none",'--sd-8-1iXufb': isAnimated ? strokeDashoffset : 0,'--sd-9-1iXufb': isAnimated ? strokeDasharray : 0}}
 className={`views-block ${styles.Svg}`}
>
<path
  data-testid="Tysiav2Dashboard.SvgPath"
  data-view-path={viewPath}
 fillRule="evenodd"
 clipRule="evenodd"
 d="M.857 0A.857.857 0 000 .857V6c0 .473.384.857.857.857h3.429A.857.857 0 005.143 6V.857A.857.857 0 004.286 0H.857zm6 .857c0-.473.384-.857.857-.857h3.429c.473 0 .857.384.857.857V2.58a.857.857 0 01-.857.857H7.714a.857.857 0 01-.857-.857V.857zm0 5.143c0-.473.384-.857.857-.857h3.429c.473 0 .857.384.857.857v5.143a.857.857 0 01-.857.857H7.714a.857.857 0 01-.857-.857V6zM0 9.42c0-.473.384-.857.857-.857h3.429c.473 0 .857.384.857.857v1.723a.857.857 0 01-.857.857H.857A.857.857 0 010 11.143V9.42z"
 style={{'--f-12-1iXufb': fill2}}
 className={`views-block ${styles.SvgPath}`}
/>
</svg>
{children}
</React.Fragment>)
}